<template>
  <div>
    <Nav isActive="Test"/>   
    <div class="pageWD shadowBox mT20 minHeight">
         <div class="pheader flex flex-sb think">
         <img src="../../assets/images/zycp.png" style="width:145px; height:58px" />   
         </div> 
       <div class="testbox" style="margin-left:25px;margin-right:25px" @click="tapMe('1')">
        <div class="t">员工职业测评</div>
        <div class="n">共计42题</div>
        <div class="d">职业兴趣是职业选择的重要因素，当您所从事的职业和您的职业兴趣类型匹配时，个人潜能可以得到最彻底的发挥...</div>
       </div>
       <div class="testbox" @click="tapMe('2')">
        <div class="t" >个人价值倾向测评</div>
         <div class="n">共计64题</div>
         <div class="d">价值需求测评工具常应用于招聘中，目的是分析应聘者的价值需求倾向与所申请岗位特性是否匹配，为企业的用人决...</div>
       </div>    
   </div> 
<div style="position:fixed;left:0;top:0;right:0;bottom:0;width:100%;height:100%; opacity: 0.5;
background: #000;overflow:hidden"  v-if="dialogVisible" ></div>
<div class="fixdalert" v-if="dialogVisible">
  <div  class="dep"  :style="{width:imgWt,height:imgHt}">
      <div class="closex">
        <i class="iconfont icon-a-5_guanbi" @click="hideMe"  style="color:#ccc;background:#fff;border-radius:50%;font-size:24px"></i>
      </div>
      <div class="in" v-if="type=='1'">
         <div class="ht">
          <p>职业兴趣是职业选择的重要因素，当您所从事的职业和您的职业兴趣类型匹配时，个人潜能可以得到最彻底的发挥，工作业绩也更加显著。在职业兴趣测试的帮助下，您了解自己的职业性格，充分发挥自己的职业潜力，并利用职业性格优势规划岗位晋升路线。</p>
          <p>职业测评基于情景判断和职业性格测验技术，通过42道人格类型与职业类型的试题，对您的职业基本素质，管理能力，创业能力进行多维度分析，通过测试职业兴趣倾向，给出对应的意见或建议，并提供 相应的提升课程推荐，推动职业兴趣的培养。</p>
         </div>         
      </div>
      <div class="in" v-if="type=='2'">   
        <div class="ht">         
          <p class="textStyle">价值需求测评工具常应用于招聘中，目的是分析应聘者的价值需求倾向与所申请岗位特性是否匹配，为企业的用人决策提供依据，以降低招聘的主观性。一般用在简历筛选之后，文化匹配度测评、行为面试、经验问话之前，可在应聘者笔试环节一起使用，以在面试前过滤一批价值需求不符合的人员。
      价值需求测评结果反映的是该应聘者的价值需求与所申请岗位之间的吻合程度，以及应聘者的个人发展方向，它为企业用人决策提供了量化的依据，吻合度高的应聘者应优先考虑录用，这就避免了面试考官的个人片面性，降低了其主观因素。</p>
        </div>         
      </div>
       <div  class="fbtn">
           <el-button type="primary" style="width:368px;height:54px;font-size:24px;margin:0px auto; border:0;color:#4B8BFB;background:#fff"  @click="subForm">开始测评</el-button>
       </div>
  </div>
</div>   
  </div>
</template>
<script>
import Cookies from "js-cookie";
import Nav from "../../components/Nav.vue";
export default {  
  components: {Nav}, 
   data() {
      return {
        dialogVisible:false,
        type:'1',
        imgHt:null,
        imgWt:null
       };
    },
    created() {    
       var ht =  document.documentElement.clientHeight - 200//577    
       console.log(ht)  
       var b = 628/ht
       this.imgWt = parseInt(760/b)+'px'
       this.imgHt = ht +'px'
       console.log(imgWt); console.log(imgHt)
    },
    methods: {  
      subForm(){
        if(this.type=='1'){
           this.$router.push({path:'/test/employee',query:{type:this.type}});
        }
        if(this.type=='2'){
           this.$router.push({path:'/test/individual',query:{type:this.type}});
        }
        
      } , 

      hideMe(){
        this.dialogVisible  =false
      },
      tapMe(type){    
        this.type = type
        this.dialogVisible = true    
      },

    }
  };
</script>
<style scoped>



>>> .el-dialog{
  background:transparent;border:0;box-shadow:none
}
>>> .el-dialog__body{
  padding:0;
   max-height: 557px !important;
      min-height: 100px;
      overflow-y: hidden;
}
.testbox{
 background:url(../../assets/images/cp_picture_gr.png) no-repeat;
 width:564px;height:360px;
 float:left;
 margin-top:25px
}
.testbox .t{
  text-align:center;
  font-size:36px;
  font-weight:bold;
  color:#4B9AFB;
  padding-top:90px
}
.testbox .n{
  width: 71px;
  height: 20px;
  background: #fff;
  border-radius: 2px;
  font-size:12px;
  line-height:20px;
  color:#999999;
  margin:110px 0 0 40px;
  text-align:center;
  border:1px solid #999
  
}
.testbox .d{ 
  height: 44px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #999999;
  line-height: 27px;
  padding:20px 40px 0 40px
}
.testbox:hover .d{
  color:#4B9AFB;
  cursor:pointer;
}
.testbox:hover .n{
  color:#4B9AFB;
  border:1px solid #4B9AFB;
  cursor:pointer;
}
.testbox:hover {
  box-shadow: 0px 1px 10px 0px rgb(0 0 0 / 10%);
  cursor:pointer;
}
.fixdalert{
  position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%
}
.dep{
  background:url(../../assets/images/cp_picture_ks.png) no-repeat;
  background-size:cover;
  margin:100px auto;
  position:relative
}

.dep .in{
  width: 100%;
  font-size: 18px;
  font-family: Source Han Sans CN, Source Han Sans CN-Normal;
  font-weight: Normal;
  text-align: center;
  color: #666666;
  line-height:150%;
  margin:0  auto;
  padding-top:10%
}
.dep .in .ht{
  height:30%;
  overflow:hidden;
  margin:0 10%
}
.dep .in p{
  text-align:left
}
>>>.el-dialog__header{
  padding:0
}
.fbtn{
  position:absolute;
  left:0px;
  width:100%;
  bottom:2%;
  right:0;
  text-align:center
}
.closex{
  position:absolute;
  right:-20px;
  top:10PX
}
</style>


// WEBPACK FOOTER //
// src/views/Test/index.vue